<template>
  <div
    class="form-item"
    :class="{ 'form-error': isEmailError || isEmailWrongError || isFormatError }"
  >
    <div class="form-item--with-submit">
      <input
        id="email"
        v-model="email"
        name="email"
        type="text"
        :placeholder="placeholder"
        aria-describedby="newsletter-email-error"
        :aria-label="ariaLabel"
        @change="hideError"
      />
      <button type="submit" class="button is-primary" @click="submitEmail">{{ buttonTxt }}</button>
    </div>
    <p v-show="isEmailError" class="form-error--message">{{ errorTxt }}</p>
    <p v-show="isFormatError" class="form-error--message">{{ errorFormat }}</p>
    <p v-show="isEmailWrongError" class="form-error--message">{{ emailWrongError }}</p>

    <div v-if="message !== ''" class="form-success--message">
      <span class="arrow-validation">
        <svg class="icon">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#subscribe-icon"></use>
        </svg>
      </span>
      {{ message }}
    </div>
  </div>
</template>

<script>
import 'whatwg-fetch';

export default {
  name: 'newsletter-subscription-form',
  props: {
    errorTxt: { type: String },
    errorFormat: { type: String },
    placeholder: { type: String },
    buttonTxt: { type: String },
    actionUrl: { type: String },
    tagging: { type: Object, required: true },
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      email: '',
      message: '',
      isEmailError: false,
      isEmailWrongError: false,
      isFormatError: false,
      emailWrongError: '',
    };
  },
  methods: {
    checkStatus(response) {
      if (response.status >= 200 && response.status < 300) {
        return response;
      }

      /* istanbul ignore next */
      const error = new Error(response.statusText);
      error.response = response;
      throw error;
    },
    parseJSON(response) {
      return response.json();
    },
    checkResult(result) {
      return new Promise((resolve, reject) => {
        if (result) {
          resolve(result);
        } else {
          reject();
        }
      });
    },
    onResult(result) {
      if (result.success) {
        try {
          dataLayer.push(this.tagging);
        } catch {
          console.warn('datalayer is not defined');
        }

        if ((result.url !== '' && result.message === '') || result.message === null) {
          window.location = result.url;
        }
        if (result.url === '' || (result.url === null && result.message !== '')) {
          this.message = result.message;
        }
      } else {
        this.isEmailWrongError = true;
        this.emailWrongError = result.message;
      }
    },
    submitEmail() {
      if (this.email && this.validateEmail()) {
        fetch(this.actionUrl, {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: this.email }),
        })
          .then(this.checkStatus)
          .then(this.parseJSON)
          .then(this.onResult)
          .catch((error) => {
            /* istanbul ignore next */
            if (error) {
              console.error(`request failed [${this.actionUrl}]`, error);
            }
          });
      } else if (this.email) {
        this.isFormatError = true;
      } else {
        this.isEmailError = true;
      }
    },
    hideError() {
      this.isEmailError = false;
      this.isFormatError = false;
      this.isEmailWrongError = false;
    },
    validateEmail() {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\d-]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
  },
};
</script>
